import { Enum } from "./Enum";

export const CfaMethodEnum: Enum[] = [
  { id: 'requested', name: 'Requested' },
  { id: 'waived', name: 'Waived' },
];